module.exports = "/_next/static/images/user-cover-default-dd32c10b91368ffded8033804d3eb461.jpg";